module.exports = __webpack_public_path__ + "media/images/soar/site/plans_2-4475bf40c1e6371d5407a6000fa788bf.svg";